module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-movie-15-years.d7071acc.svg";